import React, {useState} from 'react';
import {LoginLoader} from '../';

const Login = () => {
    return <LoginLoader />;
};

export default Login;
